import { mapGetters, mapActions, mapMutations } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import propertyPoiRecord from '@/dpp/components/propertypoirecord/property-poirecord.vue';
import mvtCardSchool from '@/common/components/mvtcardschool/mvt-cardschool.vue';
import dppCtaCard from '@/dpp/components/dppctacard/dpp-ctacard.vue';
import mvtBreadcrumb from '@/common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
export default {
    name: 'propertyStaticMap',
    inject: ['$eventBus'],
    props: ['disableCollapse'],
    data() {
        return {
            componentMounted: false,
            marketArr: null,
            index: 0,
            whiteList: ['grocery', 'cafes', 'restaurants', 'park'],
            dppCardOpt: {
                title: 'Learn About The Neighborhood',
                sub: 'Our experienced agents can help you learn more about the neighborhood, attractions, parks, schools, and more.',
                icon: 'icon-user-group',
                cta: 'Get a free consultation',
                hotleadType: 'PaymentCalcDPP',
                section: 'Static Map',
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getNearbyPois', 'getNearbySchools']),
        selectSchool() {
            if (this.index === 0 && this.getNearbySchools && this.getNearbySchools.length) {
                return this.getNearbySchools;
            } else {
                return null;
            }
        },
        selectPoi() {
            if (!this.selectSchool && this.index >= 0) {
                return this.getFilteredPois[this.index - 1];
            }
        },
        getFilteredPois() {
            let array = this.getNearbyPois.filter((item) => {
                return this.whiteList.includes(item.type);
            });
            if (array && array.length > 1) {
                array.forEach(poi => {
                    poi.minlist = poi.list && poi.list.length > 5 ? poi.list.slice(0,5) : poi.list
                })
                array.sort((a, b) => {
                    return this.whiteList.indexOf(a.type) - this.whiteList.indexOf(b.type);
                });
            }
            return array || [];
        },
    },
    components: {
        mvtShifter,
        mvtMapStatic,
        propertyPoiRecord,
        mvtCardSchool,
        dppCtaCard,
        mvtBreadcrumb
    },
    methods: {
        ...mapActions('dpp', ['fetchNearbyPois']),
        popMapView(params) {
            this.$eventBus.$emit('property-pop-map', params);
        },
        select(index) {
            this.index = index;
        },
        initial() {
            let marketArray = [{ lat: this.dpp.geo.lat, lng: this.dpp.geo.lng, type: this.dpp.propertyType }];
            if (this.getNearbySchools) {
                this.getNearbySchools.forEach((school, i) => {
                    if (i < 5) {
                        marketArray.push({
                            lat: school.latitude,
                            lng: school.longitude,
                            type: 'school',
                        });
                    }
                });
            }
            if (this.getFilteredPois) {
                this.getFilteredPois.forEach((item) => {
                    if (item && item.list && item.list.length) {
                        item.list.forEach((poi, i) => {
                            if (i < 5) {
                                marketArray.push({
                                    lat: poi.lat,
                                    lng: poi.lon,
                                    type: item.type,
                                });
                            }
                        });
                    }
                });
            }
            this.marketArr = marketArray;
        },
    },
    mounted() {
        var that = this;
        this.componentMounted = true;
        var data = {
            latitude: this.dpp.geo.lat,
            longitude: this.dpp.geo.lng,
            propertyId: this.dpp.propertyId,
        };
        this.fetchNearbyPois(data).then(() => {
            that.initial();
        });

        this.$eventBus.$on('property-staticmap-select', this.select);
    },
};
